// Landing copy, zh + en. Browser language decides; the nav toggle
// persists an explicit choice (clotho_lang — same key as the dashboard,
// so language follows the visitor across surfaces).
const zh = {
  meta: {
    title: 'clotho — 非托管 USDT/USDC 支付网关(8 链)',
    description:
      'clotho 是面向开发者的非托管 USDT/USDC 支付网关。服务器只持有你的扩展公钥,为每笔订单派生独立收款地址,永远不接触私钥。支持 TRON、BSC、Ethereum、Arbitrum、Optimism、Base、Polygon、Avalanche 八条链;兼容 Coinbase Commerce、NOWPayments、BTCPay、CoinPayments、UdunCloud 接入格式,改 base URL 即迁移。',
  },
  nav: { features: '功能', docs: '文档', console: '控制台', start: '开始接入' },
  hero: {
    badge: '非托管 · 8 链 · USDT / USDC',
    title1: '收 USDT,',
    title2: '私钥永远在你手里',
    sub: 'clotho 是面向开发者的非托管稳定币收款网关。服务器只持有你的扩展公钥 —— 能为每笔订单派生收款地址,永远无法动用资金。一个钱包,八条链。',
    ctaStart: '5 分钟开始接入',
    ctaDocs: '阅读文档',
    terminalTitle: '创建订单',
    webhookTitle: '签名回调',
  },
  stats: [
    { value: '0', label: '私钥触达服务器' },
    { value: '8', label: '条链 · TRON 到 Base' },
    { value: '5', label: '家网关格式兼容' },
    { value: '3 天', label: 'Webhook 自动重试' },
  ],
  features: {
    title: '为什么是 clotho',
    sub: '从密钥模型到回调投递,每一层都按支付系统的标准构建。',
    items: [
      {
        icon: 'gravity-ui:shield-check',
        title: '真正非托管',
        body: '钱包在你的浏览器里生成,服务器只见 xpub。没有提现按钮、没有热钱包、没有冻结风险 —— 资金直达你控制的地址。',
      },
      {
        icon: 'gravity-ui:branches-down',
        title: '每单独立地址',
        body: '从你的 xpub 按 BIP44 派生,订单与到账精确对应。助记词随时可导入 TronLink / Trust Wallet 验证。',
      },
      {
        icon: 'gravity-ui:bell',
        title: '签名 Webhook',
        body: 'HMAC-SHA256 对原始字节签名,带重放窗口与投递去重。16 次退避重试跨 3 天,死信可在控制台一键重放。',
      },
      {
        icon: 'gravity-ui:credit-card',
        title: '托管收银台',
        body: '建单即得收款链接:二维码、倒计时、实时到账状态,中英双语自适应。也可以只取地址自己渲染。',
      },
      {
        icon: 'gravity-ui:eye',
        title: '链上风控',
        body: '每笔入金的付款方实时比对 OFAC 制裁名单,命中资金隔离并告警;大额订单在筛查不可用时默认拒绝。',
      },
      {
        icon: 'gravity-ui:code',
        title: '开发者优先',
        body: '幂等键、RFC 7807 错误、OpenAPI 3.1 参考、Go/Node/Python 验签示例。test 环境直连公共测试网,水龙头即可全流程演练。',
      },
    ],
  },
  compat: {
    title: '从别家网关迁来?不用改代码',
    sub: '原样兼容五家网关的 API 与回调格式 —— 改 base URL、换密钥,你的对接代码与验签逻辑原封不动,资金从托管账户变成你自己的钱包。',
    names: ['Coinbase Commerce', 'NOWPayments', 'BTCPay', 'CoinPayments', 'UdunCloud'],
    link: '查看迁移指南 →',
  },
  how: {
    title: '三步上线',
    steps: [
      { title: '生成钱包', body: '浏览器内生成 24 词助记词,只上传公钥。' },
      { title: '创建订单', body: '一个 API 调用,拿到收款地址和收银台链接。' },
      { title: '收到回调', body: '链上确认后,签名 webhook 推到你的服务器。' },
    ],
  },
  cta: {
    title: '准备好收第一笔 USDT 了吗?',
    sub: '注册到拿到收款地址,不超过 3 分钟。test 环境免费演练。',
    button: '立即开始',
  },
  app: {
    title: '自托管钱包 App',
    sub: '收款散落在每笔订单的地址里?用我们的开源钱包(Android)一键归集到主钱包 —— TRON 走能量委托近乎零成本,EVM 自动分发 gas。私钥只在你的设备上。',
    download: '下载 Android APK',
    source: '查看源码(GPL-3.0)',
    note: '密钥永不离开设备 · 与平台同源派生,可审计可自行构建',
  },
  footer: { docs: '文档', console: '商户控制台', api: 'API 参考' },
}

const en: typeof zh = {
  meta: {
    title: 'clotho — Non-custodial USDT/USDC gateway across 8 chains',
    description:
      'clotho is a developer-first, non-custodial USDT/USDC payment gateway. Accept stablecoins on TRON, BSC, Ethereum, Arbitrum, Optimism, Base, Polygon and Avalanche without ever giving up your keys. Drop-in compatible with Coinbase Commerce, NOWPayments, BTCPay, CoinPayments and UdunCloud — change the base URL and keep your code.',
  },
  nav: { features: 'Features', docs: 'Docs', console: 'Console', start: 'Get started' },
  hero: {
    badge: 'Non-custodial · 8 chains · USDT / USDC',
    title1: 'Accept USDT.',
    title2: 'Keep your keys.',
    sub: 'clotho is a developer-first, non-custodial stablecoin gateway. The server holds only your extended public key — enough to derive a fresh deposit address per order, never enough to spend. One wallet, eight chains.',
    ctaStart: 'Integrate in 5 minutes',
    ctaDocs: 'Read the docs',
    terminalTitle: 'Create an order',
    webhookTitle: 'Signed webhook',
  },
  stats: [
    { value: '0', label: 'private keys on our servers' },
    { value: '8', label: 'chains · TRON to Base' },
    { value: '5', label: 'gateway dialects spoken' },
    { value: '3 days', label: 'webhook retries' },
  ],
  features: {
    title: 'Why clotho',
    sub: 'Every layer built to payment-system standards, from the key model to delivery.',
    items: [
      {
        icon: 'gravity-ui:shield-check',
        title: 'Actually non-custodial',
        body: 'Wallets are generated in your browser; the server only ever sees an xpub. No withdraw button, no hot wallet, no freeze risk — funds land in addresses you control.',
      },
      {
        icon: 'gravity-ui:branches-down',
        title: 'One address per order',
        body: 'BIP44-derived from your xpub, so orders map exactly to deposits. Import the mnemonic into TronLink or Trust Wallet any time to verify.',
      },
      {
        icon: 'gravity-ui:bell',
        title: 'Signed webhooks',
        body: 'HMAC-SHA256 over raw bytes with a replay window and delivery dedup. 16 backoff retries across 3 days; dead letters replay from the console.',
      },
      {
        icon: 'gravity-ui:credit-card',
        title: 'Hosted checkout',
        body: 'Every order ships with a pay link: QR code, countdown, live payment status, bilingual out of the box. Or take the raw address and render your own.',
      },
      {
        icon: 'gravity-ui:eye',
        title: 'On-chain screening',
        body: 'Every sender is checked against the OFAC sanctions list in real time; hits are quarantined and alerted, and large orders fail closed if screening is down.',
      },
      {
        icon: 'gravity-ui:code',
        title: 'Developer-first',
        body: 'Idempotency keys, RFC 7807 errors, OpenAPI 3.1, verification samples in Go/Node/Python. The test environment runs against public testnets — rehearse everything with faucet funds.',
      },
    ],
  },
  compat: {
    title: 'Migrating from another gateway? Keep your code.',
    sub: 'Wire-compatible with five gateways — change the base URL and credentials; your integration and signature checks keep working, while funds settle to your own wallet instead of a custodian.',
    names: ['Coinbase Commerce', 'NOWPayments', 'BTCPay', 'CoinPayments', 'UdunCloud'],
    link: 'Read the migration guide →',
  },
  how: {
    title: 'Live in three steps',
    steps: [
      { title: 'Generate a wallet', body: 'A 24-word mnemonic, created in your browser. Only public keys are uploaded.' },
      { title: 'Create an order', body: 'One API call returns a deposit address and a hosted checkout URL.' },
      { title: 'Get the webhook', body: 'After on-chain finality, a signed webhook hits your server.' },
    ],
  },
  cta: {
    title: 'Ready for your first USDT?',
    sub: 'Sign-up to first deposit address in under 3 minutes. The test environment is free to rehearse.',
    button: 'Start now',
  },
  app: {
    title: 'Self-custody wallet app',
    sub: 'Payments land in a fresh address per order — consolidate them in one tap with our open-source wallet (Android). TRON sweeps via energy delegation at near-zero cost; EVM auto-distributes gas. Keys live on your device only.',
    download: 'Download Android APK',
    source: 'View source (GPL-3.0)',
    note: 'Keys never leave the device · same derivation as the platform, audit it or build it yourself',
  },
  footer: { docs: 'Docs', console: 'Merchant console', api: 'API reference' },
}

export type Lang = 'zh' | 'en'

export function pickLang(): Lang {
  try {
    const stored = localStorage.getItem('clotho_lang')
    if (stored === 'zh' || stored === 'en') return stored
  } catch {
    /* storage unavailable */
  }
  return navigator.language.toLowerCase().startsWith('zh') ? 'zh' : 'en'
}

export function applyLang(lang: Lang): void {
  document.documentElement.lang = lang === 'zh' ? 'zh-Hans' : 'en'
  document.title = dicts[lang].meta.title
  const desc = document.querySelector<HTMLMetaElement>('meta[name="description"]')
  if (desc) desc.content = dicts[lang].meta.description
}

export function saveLang(lang: Lang): void {
  try {
    localStorage.setItem('clotho_lang', lang)
  } catch {
    /* storage unavailable */
  }
  applyLang(lang)
}

export const dicts: Record<Lang, typeof zh> = { zh, en }
